import {
  Attachment,
  Content,
  ContentAudience,
  DateTimeConverter,
  PublicationType,
  PublisherReviewInfo,
  UserProfile,
  WorkflowState,
} from '@amzn/awscat-pattern-library-service-model';
import { JsonObject, JsonProperty } from 'json2typescript';
import { DateTime } from 'luxon';

@JsonObject('Publication')
class Publication {
  @JsonProperty('content', Content)
  // @ts-expect-error TS2322 - strict migration
  content: Content = undefined;
  @JsonProperty('workflowId', Number, true)
  workflowId?: number = undefined;
  @JsonProperty('contentAudience', String)
  // @ts-expect-error TS2322 - strict migration
  contentAudience: ContentAudience = undefined;
  @JsonProperty('contentOwner', UserProfile)
  // @ts-expect-error TS2322 - strict migration
  contentOwner: UserProfile = undefined;
  @JsonProperty('publicationDate', DateTimeConverter)
  // @ts-expect-error TS2322 - strict migration
  publicationDate: DateTime = undefined;
  @JsonProperty('publicationType', String)
  // @ts-expect-error TS2322 - strict migration
  publicationType: PublicationType = undefined;
  @JsonProperty('attachments', [Attachment], true)
  attachments?: Attachment[] = undefined;
  @JsonProperty('publicationState', String)
  // @ts-expect-error TS2322 - strict migration
  publicationState: WorkflowState = undefined;
  @JsonProperty('publisherReviewInfo', PublisherReviewInfo, true)
  publisherReviewInfo?: PublisherReviewInfo = undefined;
}

export default Publication;
